import clsx from "clsx";
import { FC, ReactNode } from "react";

import { Icon } from "@tsmono/react/icons";

import styles from "./EditButton.module.css";

interface EditButtonProps {
  onClick: () => void;
  title?: string;
  // "link"  — link-blue text, no border (used in card headers).
  // "pill"  — matches TagChip's outline-only style so the button can
  //           sit beside chips without standing out.
  variant?: "link" | "pill";
  // Override the label text shown next to the pencil icon. Defaults to
  // "Edit". Pass a `<em>…</em>` (or any ReactNode) when the action
  // needs to label itself — e.g. the tag-strip's Edit pill, where a
  // bare "Edit" reads as confusing when no tags are present.
  children?: ReactNode;
}

// Compact pencil-prefixed Edit button used wherever an Edit affordance is
// surfaced (inline tag row + metadata card header).
export const EditButton: FC<EditButtonProps> = ({
  onClick,
  title,
  variant = "link",
  children,
}) => (
  <button
    type="button"
    className={clsx(
      styles.button,
      variant === "pill" ? styles.pill : styles.link,
      "text-size-smallest"
    )}
    onClick={onClick}
    title={title ?? "edit"}
  >
    <Icon name="pencil" />
    {children ?? "edit"}
  </button>
);
